export const submissionEndpoints = {
  submit: (schemaId) => `/submissions/submit/${schemaId}`,
  getAll: "/submissions",
  getById: (id) => `/submissions/${id}`,
  getBySector: (sector) => `/submissions/sector/${sector}`,
  getByReport: (reportId) => `/submissions/report/${reportId}`,
};

